import React from "react";

import { Container } from "react-bootstrap";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import EventsComponent from "../components/Events.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const Events = () => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("Events")} />
      <BannerComponent description="" title={t("Events")} />
      <Container className="mb-5 galleryContainer">
        <EventsComponent />
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Events;
